/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { T as TolgeeT, useTranslate } from '@tolgee/react'

const useT = () => {
  const { t } = useTranslate()
  return { t, T: TolgeeT }
}

export default useT
